export default {"src":"/_next/static/media/stem-splitter.cbc1cbc5.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};